import React, { Component } from "react";
//import {  storeProducts, detailProduct } from "./data";
import {   detailProduct } from "./data";
//import firebase from "./components/Fireb"
import {storage} from "./components/Fireb"
import * as firebase from 'firebase';
const ProductContext = React.createContext();

class ProductProvider extends Component {
  state = {
    products: [],

    //storeProducts:[],
    detailProduct: detailProduct,
    cart: [],
    modalOpen: false,
    modalOpen2: false,
    modalProduct: detailProduct,
  
    cartSubTotal: 0,
    cartTax: 0,
    cartTotal: 0,

    
    image: null,
      url: '',
      progress: 0,
      btn:true,
      btn2:true,
     uid: ''
      
  };

  




  handleChange2 = (e) => {
    if (e.target.files[0]) {
      const image = e.target.files[0];
      this.setState(() => ({image,btn:false,btn2:false}));
      
    }
  
  }
  handleChange3 = () => {
     this.setState(() => ({image: null,btn:true,btn2:true}));
      
    
  }
      
   uploadPhotoAsync = (uri, filename) => {
    
    this.setState(() => ({btn:true}));
       return new Promise(async (res, rej) => {
           const response = await fetch(uri);
           const file = await response.blob();

           
               const {image} = this.state;
               const uploadTask = storage.ref(`images/${image.name}`).put(image);
           uploadTask.on(
               "state_changed",
               snapshot => { 
                   const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                  this.setState({progress});},
               err => {
                   rej(err);
               },
               async () => {
                   const url = await uploadTask.snapshot.ref.getDownloadURL();
                   
                   res(url);
               }
           );
       });
   };










  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => { if(user) {
  
      this.setState({ uid: user.uid})
      this.setProducts();
    //console.log(this.state.uid) 
   }})
    
 
    }
  

  setProducts = () => {
    const ref = firebase.firestore().collection('storeProducts').where("vid", "==", this.state.uid);
    ref.get().then((querySnapshot => {

   //const data = querySnapshot.docs.map(doc => doc.data());

    const data = querySnapshot.docs.map(doc => ({...doc.data(), id: doc.id}));
this.setState(
    {
      products: data        
});

}));
  

    /*let products = [];
    storeProducts.forEach(item => {
      const singleItem = { ...item };
      products = [...products, singleItem];
    });
    this.setState(() => {
      return { products };
    }, this.checkCartItems);*/
  };

  getItem = id => {
    const product = this.state.products.find(item => item.id === id);
    return product;

  };
  
  handleDetail = id => {
    
    const product = this.getItem(id);
    this.setState(() => {
      return { detailProduct: product };
    });
  };







  handleUpload   = async id  =>{
 
   const remoteUri = await this.uploadPhotoAsync();
   console.log(remoteUri);
  

   this.setState({remoteUri});  

           
   return new Promise((res, rej) => {  

 const { image } = this.state;

 
 const updateRef = firebase.firestore().collection('storeProducts').doc(id);
 this.setState(() => ({btn2:true}));
 updateRef.update({
   //text,
   //uid: this.uid,
   //timestamp: this.timestamp,
   img: remoteUri
})
         .then(ref => {
             res(ref);
         })
         .catch(error => {
             rej(error);
         });
 });
 
 }







  addToCart = id => {
    let tempProducts = [...this.state.products];
    const index = tempProducts.indexOf(this.getItem(id));
    const product = tempProducts[index];
    product.inCart = true;
    product.count = 1;
    const price = product.price;
    product.total = price;

    this.setState(() => {
      return {
        products: [...tempProducts],
        cart: [...this.state.cart, product],
        detailProduct: { ...product }
      };
    }, this.addTotals);
  };

  openModal = id => {
    const product = this.getItem(id);
    this.setState(() => {
      return { modalProduct: product, modalOpen: true };
    });
  };
  closeModal = () => {
    this.setState(() => {
      return { modalOpen: false };
    });
  };







  openModal2 = id => {
    const product = this.getItem(id);
    this.setState(() => {
      return { modalProduct: product, modalOpen2: true };
    });
  };
  closeModal2 = () => {
    this.setState(() => {
      return { modalOpen2: false };
    });
  };

  delete(id){
    firebase.firestore().collection('storeProducts').doc(id).delete().then(() => {
      console.log("Document successfully deleted!");
      window.location.assign('/');
    }).catch((error) => {
      console.error("Error removing document: ", error);
    });}

    EditonChange = (e) => {
      const state1 = this.state    
     state1.modalProduct[e.target.name] = e.target.value;
      this.setState({product:state1.modalProduct});

    }
  
    EditonSubmit=(e)   => {
    
      e.preventDefault();
      const state1 = this.state.modalProduct
      const { title, price,id } = this.state.modalProduct;
  
      const updateRef = firebase.firestore().collection('storeProducts').doc(id);
     
     updateRef.update({
       title: title,
       price: parseInt(price)
       
     }).then(() => {
      

this.setProducts();
  window.location.href='/'
  this.setState({modalOpen2:false});
    })
    
      .catch((error) => {
        console.error("Error adding document: ", error);
      });
     
      
    }

  increment = id => {
    let tempCart = [...this.state.cart];
    const selectedProduct = tempCart.find(item => {
      return item.id === id;
    });
    const index = tempCart.indexOf(selectedProduct);
    const product = tempCart[index];
    product.count = product.count + 1;
    product.total = product.count * product.price;
    this.setState(() => {
      return {
        cart: [...tempCart]
      };
    }, this.addTotals);
  };
  decrement = id => {
    let tempCart = [...this.state.cart];
    const selectedProduct = tempCart.find(item => {
      return item.id === id;
    });
    const index = tempCart.indexOf(selectedProduct);
    const product = tempCart[index];
    product.count = product.count - 1;
    if (product.count === 0) {
      this.removeItem(id);
    } else {
      product.total = product.count * product.price;
      this.setState(() => {
        return { cart: [...tempCart] };
      }, this.addTotals);
    }
  };
  getTotals = () => {
    // const subTotal = this.state.cart
    //   .map(item => item.total)
    //   .reduce((acc, curr) => {
    //     acc = acc + curr;
    //     return acc;
    //   }, 0);
    let subTotal = 0;
    this.state.cart.map(item => (subTotal += item.total));
    const tempTax = subTotal * 0.05;
    const tax = parseInt(tempTax.toFixed(2));
    const total = subTotal - tax;
    return {
      subTotal,
      tax,
      total
    };
  };
  addTotals = () => {
    const totals = this.getTotals();
    this.setState(
      () => {
        return {
          cartSubTotal: totals.subTotal,
          cartTax: totals.tax,
          cartTotal: totals.total
        };
      },
      () => {
        // console.log(this.state);
      }
    );
  };
  removeItem = id => {
    let tempProducts = [...this.state.products];
    let tempCart = [...this.state.cart];

    const index = tempProducts.indexOf(this.getItem(id));
    let removedProduct = tempProducts[index];
    removedProduct.inCart = false;
    removedProduct.count = 0;
    removedProduct.total = 0;

    tempCart = tempCart.filter(item => {
      return item.id !== id;
    });

    this.setState(() => {
      return {
        cart: [...tempCart],
        products: [...tempProducts]
      };
    }, this.addTotals);
  };
  clearCart = () => {
    this.setState(
      () => {
        return { cart: [], };
      },
      () => {
        this.setProducts();
        this.addTotals();
      }
    );
  };
  render() {
    
    return (
      <ProductContext.Provider
        value={{
          ...this.state,
          handleDetail: this.handleDetail,
          addToCart: this.addToCart,
          openModal: this.openModal,
          closeModal: this.closeModal,
          increment: this.increment,
          decrement: this.decrement,
          removeItem: this.removeItem,
          clearCart: this.clearCart,


          handleUpload:this.handleUpload,
          uploadPhotoAsync:this.uploadPhotoAsync,
          handleChange2:this.handleChange2,
          handleChange3:this.handleChange3,
          openModal2: this.openModal2,
          closeModal2: this.closeModal2,
          delete:this.delete,
          setProducts:this.setProducts,
          EditonSubmit:this.EditonSubmit,
          EditonChange:this.EditonChange,

        }}
      >
        {this.props.children}
      </ProductContext.Provider>
    );
  }
}

const ProductConsumer = ProductContext.Consumer;

export { ProductProvider, ProductConsumer };